import { useEffect, useState } from 'react';

export enum MarqueeModifier {
  HORIZONTAL = 'horizontal',
}

export interface MarqueeItem {
  url: string;
  alt: string;
}

export interface MarqueeProps {
  items: MarqueeItem[];
  duration?: number;
  modifier?: MarqueeModifier;
}

function Marquee(props: MarqueeProps) {
  const [items, setItems] = useState<MarqueeItem[] | undefined>(undefined);

  useEffect(() => {
    // Need to make sure, that items.length is even to avoid jumps in animation
    // Duplicate entries if only two items exist
    // Hide animation if only one item exist

    const hasOddCount = props.items.length % 2 !== 0;

    if (hasOddCount && props.items.length >= 3) {
      const midItemIndex = Math.floor(props.items.length / 2);
      const list = [...props.items, props.items[midItemIndex]];
      setItems(list);
    } else if (props.items.length === 2) {
      const list = [...props.items, ...props.items];
      setItems(list);
    } else {
      setItems(props.items.length > 1 ? props.items : undefined);
    }
  }, [props.items]);

  return (
    <div className={`ct_marquee ${props.modifier ? `_${props.modifier}` : ''}`}>
      {!!items && !!items.length && (
        <div
          className="ct_marquee-content"
          style={{
            '--marquee-items-count': items.length,
            '--marquee-duration': props.duration ? `${props.duration}s` : '4s',
          } as React.CSSProperties}
        >
          {items.map((item, index) => (
            <div key={index} className="ct_marquee-item">
              <div className="ct_marquee-img">
                <img src={item.url} alt={item.alt} />
              </div>
            </div>
          ))}
          {items.map((item, index) => (
            <div key={index} className="ct_marquee-item">
              <div className="ct_marquee-img">
                <img src={item.url} alt={item.alt} />
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

Marquee.defaultProps = { ...{} };

export default Marquee;
